import { Entity } from 'types/common';
import * as React from 'react';
import { GlobalSettingsType } from '../useGlobalSettingsHook';
import { AuthenticatedUser } from 'types/AuthenticatedUser';
import { useSelector } from 'react-redux';
import { selectAsyncChangeLoading } from '../../slice/selectors';
import { newDate } from '../utils';

export interface EndTimeListenerProps<T> {
  userName: Entity<string> | null;
  equipments: Entity<number>[];
  globalSettings: GlobalSettingsType;
  user: AuthenticatedUser | undefined;
  endTime: Date | string;
  initialEnd: Date | string;
  isEdit: boolean;
  changeHandler: (values: T, changeStatus?: boolean | undefined) => void;
  values: T;
}
export function EndTimeListener<T>(props: EndTimeListenerProps<T>) {
  const {
    userName,
    equipments,
    endTime,
    isEdit,
    changeHandler,
    values,
    initialEnd,
  } = props;
  const [initialized, setInitialized] = React.useState(true);
  const asyncChangeLoading = useSelector(selectAsyncChangeLoading);
  const [prevEndTime, setPrevEndTime] = React.useState<
    Date | string | undefined
  >(initialEnd);
  React.useEffect(() => {
    if (!initialized) {
      let newEnd = newDate(endTime);
      let prevEnd = newDate(prevEndTime);
      if (
        equipments.length > 0 &&
        userName != null &&
        !isEdit &&
        !asyncChangeLoading &&
        prevEnd.getTime() !== newEnd.getTime()
      ) {
        changeHandler(values);
      }
      setPrevEndTime(newEnd);
    }
    setInitialized(false);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endTime]);

  return null;
}
